import useMutation from "src/hooks/useMutation";

function useManufacturerRemove(id) {
  return useMutation({
    path: `/api/v1/manufacturers/${id}`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/manufacturers`,
      shouldRevalidate: true,
    },
  });
}

export default useManufacturerRemove;
